import { render, staticRenderFns } from "./JobworkDeliveryForm.vue?vue&type=template&id=2b81208a&scoped=true"
import script from "./JobworkDeliveryForm.vue?vue&type=script&lang=js"
export * from "./JobworkDeliveryForm.vue?vue&type=script&lang=js"
import style0 from "./JobworkDeliveryForm.vue?vue&type=style&index=0&id=2b81208a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b81208a",
  null
  
)

export default component.exports